import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { SkillCategory } from '../models/skill-category';

@Injectable({
  providedIn: 'root',
})
export class SkillCategoryService {
  API_URL = `${environment.apiUrl}/skill-categories`;

  constructor(private http: HttpClient) {}

  getAllSkillCategories(): Observable<SkillCategory[]> {
    return this.http.get<SkillCategory[]>(this.API_URL).pipe(
      map((skillCategories) =>
        skillCategories.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }),
      ),
    );
  }

  getSkillCategoryById(id: number): Observable<SkillCategory> {
    return this.http.get<SkillCategory>(`${this.API_URL}/${id}`);
  }

  addSkillCategory(skillCategory: SkillCategory): Observable<SkillCategory> {
    return this.http.post<SkillCategory>(this.API_URL, skillCategory);
  }

  updateSkillCategory(skillCategory: SkillCategory): Observable<SkillCategory> {
    return this.http.put<SkillCategory>(`${this.API_URL}/${skillCategory.id}`, skillCategory);
  }

  deleteSkillCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
